import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const requireModules = require.context(
  // 其组件目录的相对路径
  './modules',
  // 是否查询其子目录
  false,
  // 匹配文件名的正则表达式
  /[\w-]+\.js$/
)
var modules = {}
requireModules.keys().forEach(fileName => {
  const module = requireModules(fileName)
  const moduleName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  modules[moduleName] = module.default
})

export default new Vuex.Store({
  modules: modules,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js